import { postJson } from "@/domain/common/client/ApiClient"
import {
  FightGetWeightClassRequestPayload,
  FightGetWeightClassResponsePayload,
} from "@bracket/idl/main/fight/payload/FightPayloadPt"
import { fightSportPayloadFromJSON } from "@bracket/idl/main/fight/model/enums/FightSportPt"
import { genderPayloadFromJSON } from "@bracket/idl/main/fight/model/enums/GenderPt"
import { divisionLabel } from "@/domain/fight/model/Fight"
import type { WeightClassOption } from "@/domain/fight/model/Fight"

/**
 * 체급 선택지 요청 값 — 폼이 들고 있는 문자열 그대로 받는다.
 *
 * 부(초등 · 중등 · 고등 · 성인)는 **서버가** 대회 시작일 + 생년월일로 정한다.
 * 학년 계산 규칙을 화면에 복제하면 서버와 갈라지므로 여기서 계산하지 않는다.
 */
interface WeightClassQuery {
  tournamentId: string
  sport: string
  birthDate: string
  gender: string
}

/** 조회 결과 — 선택지가 비어 있으면 그 부의 체급표가 아직 없다는 뜻이다 */
interface WeightClassChoices {
  options: WeightClassOption[]
  divisionLabel: string
}

async function getWeightClass(
  query: WeightClassQuery,
): Promise<WeightClassChoices> {
  const request: FightGetWeightClassRequestPayload = {
    tournamentId: query.tournamentId,
    sport: fightSportPayloadFromJSON(query.sport),
    birthDate: query.birthDate,
    gender: genderPayloadFromJSON(query.gender),
  }

  const response = await postJson<unknown>(
    "/fight/get-weight-class",
    FightGetWeightClassRequestPayload.toJSON(request),
  )
  const body = FightGetWeightClassResponsePayload.fromJSON(response)

  return {
    // 표시명은 종목 · 부 · 성별 안에서 유일하므로 그대로 선택 키로 쓴다
    options: body.data.map((payload) => ({
      key: payload.name,
      label: payload.name,
      payload,
    })),
    divisionLabel: divisionLabel(body.division),
  }
}

const FightClient = { getWeightClass }

export { FightClient }
export type { WeightClassChoices, WeightClassQuery }
